



































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import draggable from 'vuedraggable';
import '@/compiled-icons/add';
import '@/compiled-icons/arrow-down';
import '@/compiled-icons/arrow-up';
import '@/compiled-icons/delete';
import '@/compiled-icons/check';
import '@/compiled-icons/close';
import '@/compiled-icons/table-insert-after';
import '@/compiled-icons/table-insert-before';
import '@/compiled-icons/table-column-plus-after';
import '@/compiled-icons/table-column-plus-before';
import '@/compiled-icons/pencil-outline';
import '@/compiled-icons/drag-horizontal-variant';
import '@/compiled-icons/drag-vertical-variant';
import '@/compiled-icons/format-align-top';
import '@/compiled-icons/format-align-bottom';
import '@/compiled-icons/format-align-middle';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';
import DynamicDocumentRowsDesignerTemplate from '@/views/dynamicdocuments/dynamic-document-rows-designer-template.vue';

const emptyDocumentTemplate: DisguiseDto.DynamicDocumentDtoV2 = Object.freeze({
  '@type': 'DynamicDocumentDtoV2',
  'rows': []
});

// Custom Events: save
@Component({
  name: 'dynamic-document-template',
  components: {
    DynamicDocumentRowsDesignerTemplate,
    draggable
  }
})
export default class DynamicDocumentTemplate extends Vue {
  @Prop() typeSpecificSettings!: DisguiseDto.FieldTypeSpecificSettingsUnion;
  document: DisguiseDto.DynamicDocumentDtoV2 = {...emptyDocumentTemplate};
  loading: boolean = false;
  saving: boolean = false;

  created() {
    if (this.typeSpecificSettings && this.typeSpecificSettings['@type'] === 'DynamicDocumentManagementSettings') {
      this.loadDocument();
    }
  }

  @Watch('typeSpecificSettings') onTemplateUrlChanged(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.document = {...emptyDocumentTemplate};
      this.loadDocument();
    }
  }

  saveDocument() {
    this.saving = true;
    const settings = this.typeSpecificSettings as DisguiseDto.DynamicDocumentManagementSettings;
    const templateUrl = settings.endpointUrl || '';
    HTTP_SERVICE_INSTANCE.getAxios().put<DisguiseDto.DynamicDocumentDtoV2>(
        templateUrl,
        this.document
    ).then(() => {
      this.saving = false;
      this.loadDocument();
    }, (error) => {
      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
        this.$store.commit('showSnack', {
          message: `Speichern fehlgeschlagen`,
          color: 'error'
        });
      }
      this.saving = false;
    });
  }

  private loadDocument() {
    this.loading = true;
    const settings = this.typeSpecificSettings as DisguiseDto.DynamicDocumentManagementSettings;
    const templateUrl = settings.endpointUrl || '';
    HTTP_SERVICE_INSTANCE.getAxios().get<DisguiseDto.DynamicDocumentDtoV2>(
        templateUrl
    ).then((response) => {
      this.document = response.data;
      this.loading = false;
    }, (error) => {
      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
        this.$store.commit('showSnack', {
          message: `Laden fehlgeschlagen`,
          color: 'error'
        });
      }
      this.loading = false;
    });
  }

}
